
define('ldsh!modules/accounts/status/template-no-service', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="alert alert-danger" role="alert">\n    <span class="i18n" data-i18n="[html]ACCOUNTS.STATUS.' +
__e(service.toUpperCase()) +
'.NO_SERVICE"></span>\n</div>\n';

}
return __p
};});

